const calculateNodeCoordinates = (
  levelIndex,
  totalLevels,
  nodeIndex,
  totalNodes,
  max
) => {
  const totalXSpace = 400 * totalLevels + 200;
  const x = totalXSpace - (levelIndex + 1) * 400 + 100;
  const yFraction = (nodeIndex + 1) / (totalNodes + 1);
  const y = max * 70 * yFraction - 25;
  return { x, y };
};

export { calculateNodeCoordinates };
